/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grand_Grand_Pig_RaceInputs */

const fr_grand_grand_pig_race = /** @type {(inputs: Grand_Grand_Pig_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrouvez ici tous vos records personnels. Vous pouvez en ajouter ou supprimer.`)
};

/**

* @param {Grand_Grand_Pig_RaceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const grand_grand_pig_race = /** @type {((inputs?: Grand_Grand_Pig_RaceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grand_Grand_Pig_RaceInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_grand_grand_pig_race(inputs)
});